import makeStyles from '@material-ui/core/styles/makeStyles';

export const useStyles = makeStyles((theme) => {
    return {
      mainFavouriteItem: {
        width: '100%',
        cursor: 'pointer',
        color: theme.palette.text.primary,
        display: 'flex',

        [theme.breakpoints.up('md')]: {
          width: '50%',
        },

        '&:hover': {
          color: theme.palette.primary.main,
        },
      },
      mainFavouriteItemAlt: {
        width: '100%',
        cursor: 'pointer',
        background: theme.palette.primary.main,
        borderRadius: theme.spacing(0.8),
        margin: theme.spacing(0.5),
        padding: theme.spacing(0.8),
        color: theme.palette.primary.contrastText,
        fontWeight: 'bold',
        display: 'flex',
        alignItems: 'center',
        textDecoration: 'none',

        [theme.breakpoints.up('md')]: {
          width: 'auto',
        },

        '&:hover': {
          background: theme.palette.primary.light,
        },
      },
      mainFavouriteItemGrid: {
        width: '100%',
        cursor: 'pointer',
        background: theme.palette.primary.main,
        borderRadius: theme.spacing(0.8),
        margin: 0,
        color: theme.palette.primary.contrastText,
        fontWeight: 'bold',
        display: 'flex',
        alignItems: 'flex-start',
        position: 'relative',
        // padding: theme.spacing(2),
        transition: 'background 450ms cubic-bezier(.23,1,.32,1)',
        overflow: 'hidden',
        textDecoration: 'none',
        boxShadow: theme.shadows[1],

        [theme.breakpoints.up('md')]: {
          // width: 'auto',
        },

        '&:hover': {
          background: theme.palette.primary.dark,
          zIndex: '10',
          // transform: 'scale(1.05)',
          // boxShadow: '8px 8px 16px -5px #0004',

          '& $mainFavouriteItemGridBackground': {
            // transform: 'scale(1.1)',
            transform: 'scale(1.05)',
            // opacity: 0.5,
            // opacity: 0.8,
            filter: 'saturate(1) brightness(1)',
            // filter: 'saturate(1) brightness(1) contrast(0.6) blur(3px)',
          },
          '& $mainFavouriteIconGrid': {
            // transform: 'scale(1.1)',
            transform: 'scale(1.05)',
            opacity: 0.5
          }
        },
      },
      mainFavouriteItemGridBackground: {
        backgroundSize: 'cover',
        position: 'absolute',
        background: theme.palette.primary.main,
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        transition: 'transform 1050ms cubic-bezier(.23,1,.32,1), opacity 450ms cubic-bezier(.23,1,.32,1), filter 450ms cubic-bezier(.23,1,.32,1)',
        backgroundPosition: '50% 50%',
        // filter: 'saturate(0.7) brightness(0.9)',
        // filter: 'saturate(1) brightness(1) contrast(0.9)',
        //
        //
        // mask: 'linear-gradient(135deg, #fff6, white)',
        // filter: 'saturate(1) brightness(1) contrast(0.6) blur(1px)',
        // opacity: 0.6,
        //
        //
        mask: 'linear-gradient(135deg, #fffd, white)',
        filter: 'saturate(1) brightness(1) contrast(0.8) blur(0px)',
        opacity: 1,

        transform: 'scale(1.1)',
      },
      otherSourcesIcon: {
        fontSize: '1.4em',
        lineHeight: '1em',
        display: 'inline-block',
        paddingRight: '4px',
        marginRight: theme.spacing(1),
      },
      mainFavouriteLabelWrapperGrid: {
        position: "absolute",
        zIndex: 10,
        left: 0,
        paddingRight: theme.spacing(2),
        paddingTop: `${theme.spacing(0.25)}px`,
      },
      mainFavouriteLabelGrid: {
        fontSize: '1.2em',
        // textShadow: '0 0 8px #0006',
        // textShadow: `0 0 6px ${theme.palette.primary.dark}`,
        // textShadow: `0px 0px 2px ${theme.palette.primary.dark}, 0 0 6px ${theme.palette.primary.dark}`,
        // display: 'inline-block',
        lineHeight: '1.4em',
        zIndex: 100,
        background: theme.palette.primary.dark,
        boxDecorationBreak: "clone",
        padding: `${theme.spacing(0.5)}px ${theme.spacing(1)}px`,
        paddingLeft: theme.spacing(2),
      },
      hiddenSettingsButton: {
        border:'none',
        background: theme.palette.primary.main,
        cursor: 'pointer',
        width: 20,
        height: 20,
        '&:hover': {
          background: theme.palette.primary.light,
        },
      },
      mainFavouriteIcon: {
        color: theme.palette.primary.main,
        fontSize: '1.4em',
        lineHeight: '1em',
        width: '1.5em',
        height: '1em',
        display: 'inline-block',
        marginRight: theme.spacing(0.5),
      },
      mainFavouriteIconAlt: {
        color: theme.palette.primary.contrastText,
        fontSize: '1.4em',
        lineHeight: '1em',
        width: '1.5em',
        height: '1em',
        display: 'inline-block',
        marginRight: theme.spacing(0.5),
      },
      mainFavouriteIconGrid: {
        color: theme.palette.primary.contrastText,
        fontSize: '6.4em',
        lineHeight: '1em',
        width: 'auto',
        height: '1em',
        display: 'inline-block',
        // marginRight: theme.spacing(0.5),
        position: 'absolute',
        opacity: '0.3',
        bottom: '-5px',
        right: '-10px',
        transition: 'transform 450ms cubic-bezier(.23,1,.32,1), opacity 450ms cubic-bezier(.23,1,.32,1)',
        mixBlendMode: 'overlay',
        transform: 'scale(1.1)',
      },
    };
  });
